// extracted by mini-css-extract-plugin
export default {"container":"slide-up_container__UqtCb","header":"slide-up_header__lGJVl","title":"slide-up_title__lPRmi","helper":"slide-up_helper__Pzbte"};